<ng-container *ngIf="ventilationBypassMode$ | async | ready as feature">
  <div class="ventilation-settings-tile flex flex-col gap-[24px] flex-[1_0_100%]">
    <div class="flex flex-row">
      <h3>{{ '+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_SETTINGS.TITLE' | translate }}</h3>
    </div>

    <mat-radio-group
      class="flex flex-col gap-[8px]"
      [ngModel]="feature.properties.value.value"
      [disabled]="!(feature | executable: featureCommands.setMode)"
      (change)="onBypassOptionChange($event); trackVentilationBypassMode()"
    >
      <vi-radio-button
        *ngFor="let mode of feature.commands.setMode?.params?.mode.constraints.enum"
        [attr.data-at-bypass-mode]="mode"
        [value]="mode"
        [label]="mode | translateVentilationMode"
        [checked]="mode === feature.properties?.value.value"
        [attr.data-at-checked]="mode === feature.properties?.value.value"
      >
      </vi-radio-button>
    </mat-radio-group>

    <div
      class="ventilation-bypass-configuration"
      *ngIf="(feature | value2: featurePropertyKey.value) !== VentilationModes.Closed"
    >
      <ng-container *ngIf="ventilationBypassConfiguration$ | async | ready as configuration">
        <ng-container *ngIf="configuration | executable: featureCommands.setValue">
          <mat-form-field class="select-bypass-configuration" mat-select-height-large>
            <mat-label>{{
              '+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_CONFIGURATION.TITLE' | translate
            }}</mat-label>
            <mat-select
              data-at-bypass-configuration
              (selectionChange)="onBypassConfigurationChange($event)"
              name="{{
                '+INSTALLATIONS.INSTALLATION.WARM_WATER.DHW_SELECT_OPERATING_MODE' | translate
              }}"
              [value]="configuration | value2: featurePropertyKey.value"
            >
              <mat-option
                *ngFor="
                  let mode of configuration.commands?.setValue?.params?.value?.constraints?.enum
                "
                [value]="mode"
              >
                {{ mode | translateBypassConfiguration }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </ng-container>
    </div>

    <div class="temperatures-wrapper">
      <!-- 1. Bypass Minimal temperature of air supply -->
      <ng-container *ngIf="configurationTemperatureSupply$ | async | ready as feature">
        <vi-item
          *ngIf="!(feature | executable: featureCommands.setTargetTemperature)"
          class="temperature-select temperature-not-executable"
          item
          [title]="'+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_TEMPERATURE_SUPPLY' | translate"
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
        ></vi-item>

        <app-temperature-select
          *ngIf="feature | executable: featureCommands.setTargetTemperature"
          class="temperature-select"
          data-at-ventillation-temperature-supply
          title="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_TEMPERATURE_SUPPLY' | translate
          }}"
          [rangeDefinition]="
            feature
              | constraints: featureCommands.setTargetTemperature:featurePropertyKey.temperature
          "
          [value]="feature.properties?.value?.value"
          (valueChange)="onBypassConfigurationTemperatureChange($event, feature.feature)"
        ></app-temperature-select>
      </ng-container>

      <!-- 2. Bypass target room temperature -->
      <ng-container *ngIf="configurationTemperaturePerceived$ | async | ready as feature">
        <vi-item
          *ngIf="!(feature | executable: featureCommands.setTargetTemperature)"
          class="temperature-select temperature-not-executable"
          item
          [title]="
            '+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_TEMPERATURE_PERCEIVED' | translate
          "
          value="{{ feature | value2: featurePropertyKey.value }} {{
            feature | unit: featurePropertyKey.value
          }}"
        ></vi-item>
        <app-temperature-select
          *ngIf="feature | executable: featureCommands.setTargetTemperature"
          class="temperature-select"
          data-at-ventillation-temperature-perceived
          title="{{
            '+INSTALLATIONS.INSTALLATION.VENTILATION.BYPASS_TEMPERATURE_PERCEIVED' | translate
          }}"
          [rangeDefinition]="
            feature
              | constraints: featureCommands.setTargetTemperature:featurePropertyKey.temperature
          "
          [value]="feature.properties?.value?.value"
          (valueChange)="onBypassConfigurationTemperatureChange($event, feature.feature)"
        ></app-temperature-select>
      </ng-container>
    </div>
  </div>
</ng-container>
